import React from 'react'; 
import PropTypes from 'prop-types';
import SectionHeader from '../../../Basic/SectionHeader';
import CheckBox from '../../../Basic/CheckBox';

class ElectronicCommunicationfromMarketing extends React.Component {
    render() {
        const p = this.props;
        const lookup = window.osa.lookup.customerDetails.electronicCommunicationfromMarketing;
        const notifEmailTitle = lookup.items[0].name;
        const updatesEmailTitle = lookup.items[1].name;
        return (
            <div>
                <SectionHeader title={lookup.title} />
                <p>{lookup.content}</p>
                <CheckBox name={p.name + "_NotificationEmail"} title={notifEmailTitle} />
                <CheckBox name={p.name + "_UpdatesEmail"} title={updatesEmailTitle} />
            </div>);
    }
}

ElectronicCommunicationfromMarketing.propTypes = {
    name: PropTypes.string.isRequired,
};

export default ElectronicCommunicationfromMarketing;

export function ElectronicCommunicationfromMarketingValidation(name) {
    return [];
}